export function getLoaiBadgeStop(loai) {
  switch (loai) {
    case "KHO_LAY":
      return "badge-info";
    case "KHACH_HANG":
      return "badge-primary";
    case "KHO_TRA":
      return "badge-secondary";
    default:
      return "badge-light";
  }
}

export function formatLoaiDiemDung(loai) {
  switch (loai) {
    case "KHO_LAY":
      return "Điểm lấy hàng";
    case "KHACH_HANG":
      return "Điểm giao hàng";
    case "KHO_TRA":
      return "Điểm trả hàng";
    default:
      return loai;
  }
}

// Trong file: src/helpers/stopHelpers.js

export function getStopStatusBadge(status) {
  switch (status) {
    case "CHO_SOAN_HANG":
      return "badge-warning"; // Màu vàng

    // --- THÊM DÒNG NÀY VÀO ---
    case "DA_SOAN_HANG":
      return "badge-success"; // <-- Thêm màu (Xanh lá)
    // --- HẾT ---

    case "CHO_DEN":
      return "badge-info"; // Màu xanh dương
    case "DA_DEN":
      return "badge-primary";
    case "KHO_DA_XAC_MINH":
      return "badge-dark";
    case "HOAN_THANH":
      return "badge-success"; // Màu xanh lá
    default:
      return "badge-light";
  }
}

export function formatStopStatus(status) {
  switch (status) {
    case "CHO_SOAN_HANG":
      return "Chờ soạn";

    // --- THÊM DÒNG NÀY VÀO ---
    case "DA_SOAN_HANG":
      return "Đã soạn xong"; // <-- Thêm bản dịch
    // --- HẾT ---

    case "CHO_DEN":
      return "Chờ đến";
    case "DA_DEN":
      return "Đã đến (Check-in)";
    case "KHO_DA_XAC_MINH":
      return "Kho đã xác minh";
    case "HOAN_THANH":
      return "Hoàn thành";
    default:
      return status || "-";
  }
}
